import Tippy from "@tippyjs/react"
import React, { useState } from "react"
import ReactModal from "react-modal";
import HtmlContent from "../../Utils/HtmlContent";
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Navigation, Thumbs } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import agregarComplementoPedido from "../../Utils/agregarComplemento";
import { deleteOnCarBtnR } from "../../Utils/carritoR";
import { useHeaderContext } from '../../Context/HeaderContext';

ReactModal.setAppElement('#app')

const modalStyles = {
  content: {
    width: '90%',
    maxWidth: '780px',
    minHeight: '500px',
    height: 'max-content',
    maxHeight: '95vh',
    overflowY: 'auto',
    zIndex: '40',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)'
  }
}
const noSelectStyle = {
  userSelect: 'none',
  WebkitUserDrag: 'none',
};

const ComplementCardUX = ({ onChange, points = 0, ...complemento }) => {

  const {
      isCartOpen,
      setIsCartOpen,
      cartItems ,
      totalPrice,
      setCartItems,
      deleteItem,
      addOnCarBtn,
      deleteOnCarBtn,
      // Catálogo/Sugerencias de Upselling
      upsellSuggestions = [
        { id: "ramo-1", name: "Ramo Celebración Del Amor", price: 120, image: "ramo-amor.jpg", tipo: "Principal" },
        { id: "torta-1", name: "Torta Selva Negra", price: 180, image: "torta-selva-negra.jpg", tipo: "Principal" },
        { id: "caja-1", name: "Caja de Tulipanes", price: 95, image: "caja-tulipanes.jpg", tipo: "Principal" },
      ],
      userPoints
    } = useHeaderContext();

  let carrito = cartItems ?? [];
  const found = carrito.findIndex(x => x.id == complemento.id) != -1
  const uuid = "option-" + complemento.id + "-" + crypto.randomUUID()


  const [modalOpen, setModalOpen] = useState(false)
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const onModalOpen = () => {
    setModalOpen(true)
  }

  const onModalClose = () => {
    setModalOpen(false)
    setThumbsSwiper(null)
  }

  const onAddClicked = async () => {
    let isConfirmed = false
    if (points >= complemento.puntos_complemento && complemento.puntos_complemento > 0) {
      const swalRes = await Swal.fire({
        title: 'Deseas intercambiarlo con puntos?',
        text: 'Si, usar puntos',
        showCancelButton: true,
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        confirmButtonColor: '#336234',
        cancelButtonColor: '#EF4444'
      });
      isConfirmed = swalRes.isConfirmed
    }
    agregarComplementoPedido(complemento.id, isConfirmed)
  }
  const borrarProducto = (id) => {
    deleteOnCarBtnR(complemento.id)
    setModalOpen(false)
  }
  const agregarProducto = (e, id, complemento) => {
    e.target.checked = true
    $(`[id^="option-${id}"]`).prop('checked', e.target.checked);

    // onAddClicked(id, complemento)
    onChange(e, id, complemento)
    setModalOpen(false)


  }


  return <>

    <div
      className={`w-full h-[295px] md:w-52 md:h-80 p-1 md:p-2.5 rounded-[10px] inline-flex justify-start gap-2.5 
    transition-all duration-300 ease-in-out
    hover:shadow-[0px_0px_20px_1px_rgba(115,180,115,0.20)] hover:border hover:border-[#FF8555] hover:border-1
    ${!!complemento?.found ? 'border border-[#FF8555] border-1 shadow-[0px_0px_20px_1px_rgba(115,180,115,0.20)]' : ''}`
      }
    >

      <div className="w-full md:w-48 inline-flex flex-col justify-start items-center gap-1.5"
        htmlFor={uuid}


      >

        {complemento.images.length > 0 ? (
          complemento.images.map((image) =>
            image.caratula === 1 ? (
              <div key={image.id} className="relative h-[238px]">
                <img
                  className={`h-[238px] w-[178px] rounded-tl-[10px] rounded-tr-[10px] object-cover cursor-pointer transition-all duration-200 `}
                  src={image.name_imagen ? `/img-resize/${image.name_imagen}?w=178&h=238` : '/images/img/noimagen.jpg'}
                  alt={complemento.producto}
                  onClick={(e) => {
                    e.preventDefault();
                    const fakeEvent = {
                      target: { checked: !complemento?.found }
                    };
                    onChange(fakeEvent, complemento.id, complemento);
                  }}
                  onContextMenu={(e) => e.preventDefault()}
                  style={noSelectStyle}
                  loading="lazy"
                />
                <input
                  type="checkbox"
                  id={uuid}
                  name="complementos[]"
                  className="absolute opacity-0 w-0 h-0"
                  checked={complemento?.found ?? 0}
                  onChange={(e) => onChange(e, complemento.id, complemento)}
                />
                {!!complemento?.found && (
                  <div className="absolute top-3 right-3 w-6 h-6 bg-white rounded-full flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="9" viewBox="0 0 13 9" fill="none">
                      <path fillRule="evenodd" clipRule="evenodd" d="M11.8242 0.221484C12.1148 0.512109 12.1148 0.990235 11.8242 1.28086L4.79297 8.31211C4.64766 8.45742 4.45547 8.53242 4.26328 8.53242C4.07109 8.53242 3.87891 8.45742 3.73359 8.31211L0.217969 4.79648C-0.0726563 4.50586 -0.0726563 4.02773 0.217969 3.73711C0.508594 3.44648 0.986719 3.44648 1.27734 3.73711L4.26328 6.72305L10.7648 0.221484C11.0555 -0.0738281 11.5336 -0.0738281 11.8242 0.221484Z" fill="#FF8555" />
                    </svg>
                  </div>
                )}
              </div>
            ) : null
          )
        ) : (
          <div className="relative">
            <img
              className={` h-[238px] rounded-tl-[10px] rounded-tr-[10px] object-cover cursor-pointer transition-all duration-200 ${found
                ? 'ring-4 ring-customGreen ring-opacity-70 brightness-90'
                : 'hover:brightness-95'
                }`}
              src='/images/img/noimagen.jpg'
              alt="No imagen"
              onClick={(e) => {
                e.preventDefault();
                const fakeEvent = {
                  target: { checked: !found }
                };
                onChange(fakeEvent, complemento.id, complemento);
              }}
              onContextMenu={(e) => e.preventDefault()}
              style={noSelectStyle}
              loading="lazy"
            />
            <input
              type="checkbox"
              id={uuid}
              name="complementos[]"
              className="absolute opacity-0 w-0 h-0"
              checked={complemento?.found ?? 0}
              onChange={(e) => onChange(e, complemento.id, complemento)}
            />
            {!!complemento?.found && (
              <div className="absolute top-2 right-2 w-6 h-6 bg-white rounded-full flex items-center justify-center">
                <svg className="w-4 h-4 text-[#FF8555]" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
            )}
          </div>
        )}

        <div className="w-full h-12 py-px relative flex flex-col justify-start items-end gap-2.5">
          <div className="pl-2 w-full  flex-col justify-start items-start">
            <Tippy content={complemento.producto}>
              <div className="w-full self-stretch h-7 justify-center text-zinc-800 text-base font-normal font-PlusJakartaSans_Regular truncate">

                {complemento.producto}

              </div>
            </Tippy>
            <div className="flex flex-row justify-start items-center gap-4">
              <div className="flex justify-start items-center gap-2.5">
                <div className="pr-5 h-6 border-r justify-center text-zinc-800 text-base font-semibold font-PlusJakartaSans_Regular">
                  S/{Number(complemento.descuento > 0 ? complemento.descuento : complemento.precio).toFixed(0)}
                </div>

              </div>
              {complemento.puntos_complemento > 0 && (
                <div className="flex justify-start items-center gap-[5px]">
                  <div className="h-6 w-6" >
                    <img src="/images/ux/Group 3623.png" alt="" onContextMenu={(e) => e.preventDefault()}
                      style={noSelectStyle} />
                  </div>

                  <div className="w-14 h-6 justify-center text-zinc-800 text-base font-semibold font-PlusJakartaSans_Regular">
                    {complemento.puntos_complemento}pts
                  </div>
                </div>
              )}
            </div>
          </div>

        </div>

      </div>


    </div>

  </>
}

export default ComplementCardUX